import React, {useEffect} from "react";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import Application from "./Application";
import HomePage from "./components/HomePage";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";
import DmarcReporting from "./components/Pages/DmarcReporting";
import RealtimeMonitoring from "./components/Pages/RealtimeMonitoring";
import AiBased from "./components/Pages/AiBased";
import FiveTipsForEmailSecurity from "./components/Posts/FiveTipsForEmailSecurity";
import DmarcMadeEasy from "./components/Posts/DmarcMadeEasy";
import BimiImportance from "./components/Posts/BimiImportance";
import AnalyzeResults from "./components/Pages/AnalyzeResults";
import TermsAndConditions from "./components/Pages/TermsAndConditions";

const App = () => {

    useEffect(() => {
        CookieConsent.run({
            autoClearCookies: true,
            disablePageInteraction: true,

            onConsent: function (params) {
                window.dataLayer = window.dataLayer || [];

                function gtag() {
                    window.dataLayer.push(arguments);
                }

                // Dynamically insert Google Analytics script
                const script = document.createElement('script');
                script.src = "https://www.googletagmanager.com/gtag/js?id=G-45KJNPPZB1";
                script.async = true;
                script.onload = () => {
                    gtag("js", "auto"); // Avoid `new Date()` entirely
                    gtag('config', 'G-45KJNPPZB1');
                    console.log('Google Analytics script loaded and initialized');
                };

                document.head.appendChild(script); // Append the script to the <head> section
            },
            categories: {
                necessary: {
                    enabled: true,  // this category is enabled by default
                    readOnly: true  // this category cannot be disabled
                },
                analytics: {
                    enabled: false, // Disabled by default, users must consent
                    cookies: [{name: '_ga'}, {name: '_gid'}, {name: '_gat'}], // Google Analytics cookies
                    autoClear: {
                        cookies: ['_ga', '_gid', '_gat'], // Google Analytics cookies
                        reloadPage: false
                    },
                    services: {
                        ga: {
                            label: "Google Analytics",
                            cookies: [
                                {
                                    name: /^(_ga|_gid|_gat)/
                                }
                            ]
                        },

                    }
                }
            },
            language: {
                default: 'en',
                translations: {
                    en: {
                        consentModal: {
                            title: 'We use cookies',
                            description: 'We use cookies to improve your experience on our site. You can manage your preferences below.',
                            acceptAllBtn: 'Accept all',
                            acceptNecessaryBtn: 'Reject all',
                            showPreferencesBtn: 'Manage individual preferences'
                        },
                        preferencesModal: {
                            title: 'Manage cookie preferences',
                            description: 'Cookies allow us to enhance your browsing experience. Select your preferences below to manage the cookies you want to enable or disable.',
                            acceptAllBtn: 'Accept all',
                            acceptNecessaryBtn: 'Reject all',
                            savePreferencesBtn: 'Accept current selection',
                            closeIconLabel: 'Close modal',
                            sections: [
                                {
                                    title: 'About Cookies',
                                    description: 'Cookies are small text files stored on your device to improve site functionality, performance, and personalization. You can choose which categories to allow below.'
                                },
                                {
                                    title: 'Strictly Necessary Cookies',
                                    description: 'These cookies are essential for the proper functioning of the website. Without these cookies, certain features such as secure login or shopping cart functionality would not be possible.',
                                    linkedCategory: 'necessary'
                                },
                                {
                                    title: 'Performance and Analytics Cookies',
                                    description: 'These cookies help us analyze how visitors use the website, providing insights that allow us to improve both functionality and user experience. All data is anonymized and cannot identify individual users.',
                                    linkedCategory: 'analytics'
                                }
                            ]
                        }
                    }
                }
            }
        });
    }, []);

    return (
        <Router>
            <Routes>
                {/* Protected Routes */}
                <Route
                    path="/"
                    element={<Application/>}
                >
                    <Route path="/" element={<HomePage/>}/>
                    <Route path="dmarc-reporting" element={<DmarcReporting/>}/>
                    <Route path="realtime-monitoring" element={<RealtimeMonitoring/>}/>
                    <Route path="ai-based-dmarc-reporting" element={<AiBased/>}/>
                    <Route path="analyze-results" element={<AnalyzeResults/>}/>
                    <Route path="five-tips-for-email-security" element={<FiveTipsForEmailSecurity/>}/>
                    <Route path="dmarc-made-easy" element={<DmarcMadeEasy/>}/>
                    <Route path="terms-and-conditions" element={<TermsAndConditions/>}/>
                    <Route path="why-bimi-is-important-for-your-brand" element={<BimiImportance/>}/>
                </Route>
                <Route path="*" element={<Navigate to="/"/>}/>
            </Routes>
        </Router>
    );
};

export default App;
